<template>
  <v-container fluid class="px-6">

    <v-card>

      <v-card-title class="px-6 card-header white--text">
        <v-icon class="mr-3 white--text">mdi-format-list-bulleted</v-icon> <h3>Station List</h3>
      </v-card-title>

      <div style="max-height: calc(100vh - 190px);overflow-y:auto;">
        <v-data-table
          :headers="stationHeader"
          :items="itemsWithIndex"
          class="elevation-2 headerDtSarawak px-6 pt-6"
        >

          <template v-slot:[`item.no`]="props">
            {{ props.item.index }}
          </template>
          <template v-slot:[`item.actions`]="props">
            <template>
              <v-icon
                small
                class="mr-2 green--text"
                @click="editStationItem(props.item)"
                >mdi-pencil</v-icon
              >
              <v-icon
                small
                class="red--text"
                text
                @click="deleteStation(props.item.stationId)"
                >mdi-delete</v-icon
              >
            </template>
          </template>
        </v-data-table>
      </div>

    </v-card>

    <!------ Dialog Edit ------>
    <v-dialog persistent
    v-model="dialogEdit"
    max-width="70%" scrollable
    > 
      <v-card >

        <v-card-title class="card-header white--text">
          <v-icon class="white--text mr-2">mdi-text-box-edit</v-icon><h3>Edit Station : {{stationIdEdited}}</h3>
        </v-card-title>

        <v-card-text style="height: 80%" class="mb-4 pt-0">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">
                  Station ID 
                </v-subheader>
                <v-text-field
                  v-model="editedStationData.stationId"
                  readonly
                  hint="This field cannot be edited"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">
                  Location <span class="text-bold red--text ml-2">*</span>
                </v-subheader>
                <v-text-field
                  v-model="editedStationData.location"
                  dense
                  outlined
                  hide-details
                  :rules="[v => !!v || 'Station location name is required']"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">State</v-subheader>
                <v-text-field
                  v-model="editedStationData.stateName"
                  dense
                  outlined hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-subheader class="pa-1 black--text">
                  Longitude <span class="text-bold red--text ml-2">*</span>
                </v-subheader>
                <v-text-field
                  v-model="editedStationData.longitude"
                  dense
                  outlined hide-details
                  :rules="[v => !!v || 'Station longitude is required']"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-subheader class="pa-1 black--text">
                  Latitude <span class="text-bold red--text ml-2">*</span>
                </v-subheader>
                <v-text-field
                  v-model="editedStationData.latitude"
                  dense
                  outlined hide-details
                  :rules="[v => !!v || 'Station latitude is required']"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">Telecommunication Type</v-subheader>
                <v-text-field
                  v-model="editedStationData.telecommunicationType"
                  dense
                  outlined hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">Land Structure</v-subheader>
                <v-text-field
                  v-model="editedStationData.landStructure"
                  dense
                  outlined hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">Soil Type</v-subheader>
                <v-text-field
                  v-model="editedStationData.soilType"
                  dense
                  outlined hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">PIC Name</v-subheader>
                <v-text-field
                  v-model="editedStationData.picName"
                  dense
                  outlined hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">PIC Contact Number</v-subheader>
                <v-text-field
                  v-model="editedStationData.picPhone"
                  dense
                  outlined hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">PIC Email</v-subheader>
                <v-text-field
                  v-model="editedStationData.picEmail"
                  dense
                  outlined hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-subheader class="pa-1 black--text">
                  Time Alert Transmission <span class="text-bold red--text ml-2">*</span>
                </v-subheader
                >
                <v-select
                  :items="listTime"
                  :item-text="'name'"
                  :item-value="'value'"
                  v-model="editedStationData.timeAlertTransmission  "
                  required
                  outlined 
                  dense 
                  :rules="[v => !!v || 'Time alert is required']"
                  :menu-props="{ bottom: true, offsetY: true }"
                  hide-details
                ></v-select>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-card-title class="card-header white--text">
          <v-icon class="white--text mr-2">mdi-image-edit</v-icon><h3>Edit Picture</h3>
        </v-card-title>

        <v-card-text>
          <br>
          <v-card outlined
          :loading="loadingUploadImage"
          >
            <v-container fluid class="py-0">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-subheader class="pa-1 black--text">Station</v-subheader>
                  <a v-if="editedStationData.stationPicture != ''" :href="editedStationData.stationPicture" target="_blank">
                    <v-icon small class="ml-3 primary--text" style="text-decoration:none">mdi-message-image-outline</v-icon>
                    <span class="ml-2 primary--text" style="font-size:0.9em;">See Data Image</span>
                  </a>
                  <a v-if="editedStationData.stationPicture === ''" style="cursor:default;">
                    <v-icon small class="ml-3 black--text" style="cursor:default;">mdi-image-off</v-icon>
                    <span class="ml-2 black--text" style="font-size:0.9em;cursor:default;">No Data Image</span>
                  </a> 
                  <v-file-input
                    type="file"
                    @change="uploadPicture(uploadPic.file1, 'stationPicture')"
                    v-model="uploadPic.file1"
                    clearable
                    dense
                    outlined
                    >test</v-file-input
                  >
                </v-col>

                <v-col cols="12" sm="6">
                  <v-subheader class="pa-1 black--text">Deployment</v-subheader>
                  <a v-if="editedStationData.deploymentPicture != ''" :href="editedStationData.deploymentPicture" target="_blank">
                    <v-icon small class="ml-3 primary--text">mdi-message-image-outline</v-icon>
                    <span class="ml-2 primary--text" style="font-size:0.9em;">See Data Image</span>
                  </a>
                  <a v-if="editedStationData.deploymentPicture === ''" style="cursor:default;">
                    <v-icon small class="ml-3 black--text" style="cursor:default;">mdi-image-off</v-icon>
                    <span class="ml-2 black--text" style="font-size:0.9em;cursor:default;">No Data Image</span>
                  </a>
                  <v-file-input
                    type="file"
                    @change="uploadPicture(uploadPic.file2, 'deploymentPicture')"
                    v-model="uploadPic.file2"
                    dense
                    outlined
                    >test</v-file-input
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6">
                  <v-subheader class="pa-1 black--text">Upstream</v-subheader>
                  <a v-if="editedStationData.upstreamPicture != ''" :href="editedStationData.upstreamPicture" target="_blank">
                    <v-icon small class="ml-3 primary--text">mdi-message-image-outline</v-icon>
                    <span class="ml-2 primary--text" style="font-size:0.9em;">See Data Image</span>
                  </a>
                  <a v-if="editedStationData.upstreamPicture === ''" style="cursor:default;">
                    <v-icon small class="ml-3 black--text" style="cursor:default;">mdi-image-off</v-icon>
                    <span class="ml-2 black--text" style="font-size:0.9em;cursor:default;">No Data Image</span>
                  </a> 
                  <v-file-input
                    type="file"
                    @change="uploadPicture(uploadPic.file3, 'upstreamPicture')"
                    v-model="uploadPic.file3"
                    dense
                    outlined
                    >test</v-file-input
                  >
                </v-col>
                <v-col cols="12" sm="6">
                  <v-subheader class="pa-1 black--text">Downstream</v-subheader>
                  <a v-if="editedStationData.downStreamPicture != ''" :href="editedStationData.downStreamPicture" target="_blank">
                    <v-icon small class="ml-3 primary--text">mdi-message-image-outline</v-icon>
                    <span class="ml-2 primary--text" style="font-size:0.9em;">See Data Image</span>
                  </a>
                  <a v-if="editedStationData.downStreamPicture === ''" style="cursor:default;">
                    <v-icon small class="ml-3 black--text" style="cursor:default;">mdi-image-off</v-icon>
                    <span class="ml-2 black--text" style="font-size:0.9em;cursor:default;">No Data Image</span>
                  </a>
                  <v-file-input
                    type="file"
                    @change="uploadPicture(uploadPic.file4, 'downStreamPicture')"
                    v-model="uploadPic.file4"
                    dense
                    outlined
                    >test</v-file-input
                  > 
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          
        </v-card-text>


        <v-card-actions class="card-footer">
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogEdit=false"
            color="error"
          >
            CANCEL
          </v-btn>
          <v-btn
            @click="postEditStation"
            color="button" class="white--text px-4 mx-3"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!------ Dialog Delete ------>
    <v-dialog persistent v-model="dialogDelete" max-width="550px">
      <v-card>
        <v-card-title class="text-h5 white--text error">
          <v-icon class="white--text mr-2">mdi-delete-circle</v-icon> Delete Station : {{delSelected}}
        </v-card-title>

        <v-card-text class="pa-5 d-flex justify-center">
          <h3>Are you sure you want to delete this station? </h3>
        </v-card-text>


        <v-card-actions class="card-footer">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close">Cancel</v-btn>
          <v-btn color="button" class="white--text px-4 mx-3" @click="postDeleteStation">YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Popups/Dialogs Success Param Added-->
    <v-dialog
    v-model="dialogSuccessStationEdited"
    width="500"
    >
      <v-card>

          <v-card-title class="text-h5 white--text success">
            <v-icon class="white--text mr-2">mdi-text-box-check</v-icon>Form has been submitted
          </v-card-title>

          <v-card-text class="pa-5 d-flex justify-center">
            <h3>Station has been successfully edited</h3> <v-icon class="mb-1 ml-1">mdi-check-circle-outline</v-icon> 
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="dialogSuccessStationEdited = false"
            >
              Close
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Popups/Dialogs Error Add Station-->
    <v-dialog
    v-model="dialogErrorEditStation"
    width="500"
    >
      <v-card>

        <v-card-title class="text-h5 white--text error">
          <v-icon class="white--text mr-2">mdi-text-box-remove</v-icon>Form failed to submit
        </v-card-title>

        <v-card-text class="pa-5 d-flex justify-center">
          <h3>Something went wrong. Please make sure all required field is filled and try again <v-icon class="mb-1 ml-1">mdi-alert-circle</v-icon> </h3> 
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogErrorEditStation = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!----- Snackbar Message ---->
    <v-snackbar
        v-model="snackbarMsg"
        :color="snackbarColor"
    >
        {{ message }}

        <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbarMsg = false"
        >
            <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
    </v-snackbar>


  </v-container>
</template>

<script>
import axios from "axios";
import appMixins from '@/mixins/globalMixins'

export default {
  data: () => ({

    stationIdEdited: null,

    dialogSuccessStationEdited: false,
    dialogErrorEditStation: false,

    snackbarMsg: false,
    snackbarColor: '',
    message: '',

    listTime: [
      {name: "15 Minutes", value: "00:15:00"},
      {name: "30 Minutes", value: "00:30:00"},
      {name: "1 Hour", value: "00:00:00"},
    ],
    loadingUploadImage: false,
    urlPic1: null,
    uploadPic: {
      file1: null,
      file2: null,
      file3: null,
      file4: null,
    },
    delSelected: "",
    dialogEdit: false,
    dialogDelete: false,
    stationHeader: [
      { text: "NO.", align: "start", value: "no" },
      { text: "STATION ID", value: "stationId" },
      { text: "LOCATION", value: "location" },
      { text: "ACTIONS", value: "actions", sortable: false },
    ],
    stationData: [],

    editedStationData: {
      stationId: "",
      stateName: "",
      location: "",
      longitude: "",
      latitude: "",
      //stationStatus: "",
      alertStatus: null,
      telecommunicationType: "",
      landStructure: "",
      soilType: "",
      picName: "",
      picPhone: "",
      picEmail: "",
      stationPicture: "",
      deploymentPicture: "",
      upstreamPicture: "",
      downStreamPicture: "",
      timeAlertTransmission  : ""
      //STATION_ID_ACTIVE: "",
    },

    filterstationData: [],
    paramArray: [],
    paramItems: {
      DO_CON_ACTIVE: "",
      "4_4_DDT_ACTIVE": "",
      AG_ACTIVE: "",
      AL_ACTIVE: "",
      ALDRIN_DIELDRIN_ACTIVE: "",
      AS_ACTIVE: "",
      B_ACTIVE: "",
      BA_ACTIVE: "",
      BHC_ACTIVE: "",
      BOD_ACTIVE: "",
      BR_ACTIVE: "",
      CA_ACTIVE: "",
      CCE_ACTIVE: "",
      CD_ACTIVE: "",
      CDOM_ACTIVE: "",
      CHLORDANE_ACTIVE: "",
      CHLOROPHYLL_A_ACTIVE: "",
      CL_ACTIVE: "",
      CL2_ACTIVE: "",
      CN_ACTIVE: "",
      CO2_ACTIVE: "",
      COD_ACTIVE: "",
      COLOUR_ACTIVE: "",
      CONDUCTIVITY_ACTIVE: "",
      CR_ACTIVE: "",
      CR_III_ACTIVE: "",
      CR_IV_ACTIVE: "",
      CU_ACTIVE: "",
      DEPTH_ACTIVE: "",
      DO_SAT_ACTIVE: "",
      DOC_ACTIVE: "",
      E_COLI_ACTIVE: "",
      EC_ACTIVE: "",
      ENDOSULFAN_ACTIVE: "",
      F_ACTIVE: "",
      FC_ACTIVE: "",
      FDOM_ACTIVE: "",
      FE_ACTIVE: "",
      FLOWRATE_ACTIVE: "",
      GROSS_ALPHA_ACTIVE: "",
      GROSS_BETA_ACTIVE: "",
      HARDNESS_ACTIVE: "",
      HEDONAL_2_4_D_ACTIVE: "",
      HEPTACHLOR_EPOXIDE_ACTIVE: "",
      HG_ACTIVE: "",
      K_ACTIVE: "",
      LINDANE_ACTIVE: "",
      MBAS_ACTIVE: "",
      MG_ACTIVE: "",
      MN_ACTIVE: "",
      NA_ACTIVE: "",
      NH3N_ACTIVE: "",
      NH4_ACTIVE: "",
      NI_ACTIVE: "",
      NO2_ACTIVE: "",
      NO3_ACTIVE: "",
      OG_EDIBLE_ACTIVE: "",
      OG_MINERAL_ACTIVE: "",
      P_ACTIVE: "",
      PARAQUAT_ACTIVE: "",
      PB_ACTIVE: "",
      PCB_ACTIVE: "",
      pH_ACTIVE: "",
      PHENOL_ACTIVE: "",
      PO4_3_ACTIVE: "",
      RA226_ACTIVE: "",
      S_ACTIVE: "",
      SALINITY_ACTIVE: "",
      SE_ACTIVE: "",
      SN_ACTIVE: "",
      SO4_ACTIVE: "",
      SOLAR_BATTERY_ACTIVE: "",
      SILVEX_2_4_5_TP_ACTIV: "",
      SR_90_ACTIVE: "",
      TC_ACTIVE: "",
      TDS_ACTIVE: "",
      TEMPERATURE_ACTIVE: "",
      TOC_ACTIVE: "",
      TRIOXONE_2_4_5_T_ACTIVE: "",
      TSS_ACTIVE: "",
      TURBIDITY_ACTIVE: "",
      U_ACTIVE: "",
      VELOCITY_ACTIVE: "",
      ZN_ACTIVE: "",
      TRYPHPTOPHAN_ACTIVE: ""
    },
    stationDetails : {},
    editedIndex: -1,

    // Scroll Control
    // type: 'element',
    // selected: 'dialog',
    paramList: []
  }),

  methods: {

    getAllParams(){
      axios
      .get(this.globalUrl+'wqms/params', {
        headers: {
          Authorization: "Bearer " + this.$store.getters.user.token,
        },
      })
      .then((response) => {
        let data = response.data;

        for(let i in data){
          if(data[i].reading.includes("WQI")==false && data[i].reading.includes("SI_BOD")==false && data[i].reading.includes("SI_COD")==false 
          && data[i].reading.includes("SI_DO_SAT")==false && data[i].reading.includes("SI_NH3N")==false && data[i].reading.includes("SI_TSS")==false 
          && data[i].reading.includes("SI_pH")==false)
          {
            this.paramList.push(data[i].reading + "_ACTIVE");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },

    uploadPicture(data, fileKey) {

      this.loadingUploadImage = true;

      let formData = new FormData();

      formData.append("files", data);

      axios
        .post(this.globalUrl+'wqms/upload', formData, {
          headers: {
            Authorization: "Bearer " + this.$store.getters.user.token,
          },
        })
        .then((response) => {
          // this.stationData = response.data.filepath
          this.editedStationData[fileKey] = response.data.filepath;
          // console.log(this.editedStationData[fileKey].split('_').pop())
          // console.log(this.editedStationData[fileKey])

          console.log(response);
          this.loadingUploadImage = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingUploadImage = false;
        });
    },

    getAllStation() {

      this.stationData = [];

      axios
        .get(this.globalUrl+'wqms/stations', {
          headers: {
            Authorization: "Bearer " + this.$store.getters.user.token,
          },
        })
        .then((response) => {
          this.stationData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAllParamActive(item){

      this.filterstationData = [];

      let keyDataItem = Object.keys(item);

      axios
      .get(this.globalUrl+'wqms/stations', {
        headers: {
          Authorization: "Bearer " + this.$store.getters.user.token,
        },
      })
      .then((response) => {

        let keyData = Object.keys(response.data[0]);

        for (let i = 0; i < keyData.length; i++) {
          if (keyData[i].includes("ACTIVE") == true) {
              this.filterstationData.push(keyData[i]);
          }
        }

        for (let i = 0; i < this.filterstationData.length; i++) {
          for (let x = 0; x < keyDataItem.length; x++) {
            if (this.filterstationData[i] == keyDataItem[x]) {
              this.paramItems[this.filterstationData[i]] = item[keyDataItem[x]];
            }
          }
        }

      })
      .catch((error) => {
        console.log(error);
      });
      

    },

    editStationItem(item) {
     
      this.stationIdEdited = item.stationId;
      this.dialogEdit = true;
      this.stationDetails = item;

      //this.editedStationData = this.stationDetails;

      this.editedStationData.stationId = item.stationId;
      this.editedStationData.stationStatus = item.stationStatus;
      this.editedStationData.alertStatus = item.alertStatus;
      this.editedStationData.location = item.location;
      this.editedStationData.stateName = item.stateName;
      this.editedStationData.longitude = item.longitud.toString();
      this.editedStationData.latitude = item.latitude.toString();
      this.editedStationData.telecommunicationType = item.telecommunicationType;
      this.editedStationData.landStructure = item.landStructure;
      this.editedStationData.soilType = item.soilType;
      this.editedStationData.picName = item.picName;
      this.editedStationData.picPhone = item.picPhone;
      this.editedStationData.picEmail = item.picEmail;
      this.editedStationData.timeAlertTransmission = item.TIME_ALERT_TRANSMISSION;
      //this.editedStationData.STATION_ID_ACTIVE = item.stationId;

      this.editedStationData.stationPicture = item.stationPicture;
      this.editedStationData.deploymentPicture = item.deploymentPicture;
      this.editedStationData.upstreamPicture = item.upstreamPicture;
      this.editedStationData.downStreamPicture = item.downStreamPicture;

      

      for(let i in this.paramList){
        this.editedStationData[this.paramList[i]] = item[this.paramList[i]];
      }

    },

    postEditStation() {

      if (this.editedStationData.location != "" && this.editedStationData.longitude != ""
      && this.editedStationData.latitude != "") {

        let payload = JSON.stringify(this.editedStationData);
        console.log(payload);

        axios.put(this.globalUrl+'wqms/editstation', payload, {
          headers: {
            Authorization: "Bearer " + this.$store.getters.user.token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          this.getAllStation();
          this.dialogSuccessStationEdited = true;
          this.dialogErrorEditStation = false;
          this.dialogEdit = false;
        })
        .catch((error) => {
          console.log(error);
          this.dialogSuccessStationEdited = false;
          this.dialogErrorEditStation = true;
        });
        
      }
      else{
        this.dialogSuccessStationEdited = false;
        this.dialogErrorEditStation = true;
      }

      
    },

    deleteStation(val) {
      this.delSelected = val;
      this.dialogDelete = true;
    },

    postDeleteStation() {
      axios
        .get(
          this.globalUrl+'wqms/delstation?stationid='+this.delSelected,
          {
            headers: {
              Authorization: "Bearer " + this.$store.getters.user.token,
            },
          }
        )
        .then((response) => {
          let temp = this.stationData.findIndex(
            (item) => item.stationId === this.delSelected
          );
          this.stationData.splice(temp, 1);
          this.close();

          this.snackbarMsg= true;
          this.snackbarColor = 'success';
          this.message = 'Station has been deleted';
        })
        .catch((error) => {
          console.log(error);

          this.snackbarMsg= true;
          this.snackbarColor = 'error';
          this.message = 'Something went wrong. Please try again later';
        });
    },

    scrollTo(){
      // document.getElementById("topEditCard").scrollIntoView()
    },

    close() {
      this.dialogEdit = false;
      this.dialogDelete = false;
      this.editedStationData.stationPicture = "";
      this.editedStationData.deploymentPicture = "";
      this.editedStationData.upstreamPicture = "";
      this.editedStationData.downStreamPicture = "";
      this.stationIdEdited = null;
    }
       
  },

  computed: {
    itemsWithIndex() {
      return this.stationData.map((stationData, index) => ({
        ...stationData,
        index: index + 1,
      }));
    }
  },

  created() {
    for (let key in this.paramItems) {
      this.paramArray.push({ name: key, param: key.split("_ACTIVE")[0], value: null, min: null, max: null, outlierMin: null, outlierMax: null });
    }
  },

  mounted() {
    this.getAllStation();
    this.getAllParams();
    // this.getAllParamActive();
    this.editedStationData.downStreamPicture;
  },
};
</script>

<style lang="scss" scoped>
</style>